<template>
  <div class="recipe-card-popular" @click="showFullRecipe">
    <div class="image-container">
      <img
        v-if="imageUrl && !imageError"
        :src="imageUrl"
        class="recipe-image"
        @error="onImageError"
        alt="Recipe image"
      />
      <div
        v-else
        class="image-placeholder d-flex justify-content-center align-items-center"
      >
        <div class="spinner-border text-wait spinner-border-sm" role="status">
          <span class="visually-hidden">Загрузка...</span>
        </div>
      </div>
    </div>
    <div class="recipe-info">
      <h6 class="recipe-name mt-2 mb-1">{{ recipe.name }}</h6>
      <div class="d-flex justify-content-between align-items-center">
        <RecipeRating v-if="recipe && recipe.id" :recipe-id="recipe.id" />
        <!-- Publish status icon, only for 'My Recipes' view -->
        <span
          v-if="mode === 'my-recipes'"
          @click.stop="togglePublishStatus"
          class="publish-toggle"
          :class="{ disabled: isTogglingStatus }"
        >
          <i
            v-if="recipe.show"
            class="bi bi-check-circle-fill text-success"
            title="Снять с публикации"
          ></i>
          <i
            v-else
            class="bi bi-check-circle text-muted"
            title="Опубликовать"
          ></i>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import RecipeRating from "./RecipeRating.vue";

export default {
  name: "RecipeCardPopular",
  components: {
    RecipeRating,
  },
  props: {
    recipe: {
      type: Object,
      required: true,
    },
    mode: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      imageUrl: null,
      imageError: false,
      isTogglingStatus: false,
    };
  },
  watch: {
    recipe: {
      immediate: true,
      handler(newRecipe) {
        this.fetchRecipeImage(newRecipe);
      },
    },
    "$globalState.apiUrl"() {
      this.fetchRecipeImage(this.recipe);
    },
  },
  methods: {
    async togglePublishStatus() {
      if (this.isTogglingStatus) return;

      this.isTogglingStatus = true;
      try {
        if (this.recipe.show) {
          await this.sendCmd(`recipe.makePrivate/${this.recipe.id}`);
          this.$emit("status-changed", { id: this.recipe.id, show: false });
        } else {
          await this.sendCmd(`recipe.makePublic/${this.recipe.id}`);
          this.$emit("status-changed", { id: this.recipe.id, show: true });
        }
      } catch (error) {
        alert(error.message || "Произошла ошибка. Попробуйте снова.");
        console.error("Failed to toggle publish status:", error);
      } finally {
        this.isTogglingStatus = false;
      }
    },

    onImageError() {
      // If the first attempt fails, try again with a cache-busting parameter.
      if (this.imageUrl && !this.imageUrl.includes("?cb=")) {
        this.imageUrl = `${this.imageUrl}?cb=1`; // ${new Date().getTime()}`;
      } else {
        // If it fails even with the cache buster, then it's a real error.
        this.imageError = true;
      }
    },

    fetchRecipeImage(currentRecipe) {
      if (!currentRecipe || !currentRecipe.name || !this.$globalState.apiUrl) {
        this.imageUrl = null;
        this.imageError = false;
        return;
      }
      const encodedRecipeName = encodeURIComponent(currentRecipe.name);
      this.imageUrl = `${this.$globalState.apiUrl}/image.get/${encodedRecipeName}`;
      this.imageError = false; // Reset error on new fetch attempt
    },

    showFullRecipe() {
      this.$emit("show-full-recipe", this.recipe);
    },
  },
};
</script>

<style scoped>
.recipe-card-popular {
  cursor: pointer;
  flex-shrink: 0;
}
.recipes-scroll-list .recipe-card-popular {
  width: 186px;
}
.recipes-scroll-list .recipe-card-popular img {
  width: 186px;
  height: 186px;
}

.image-container {
  border-radius: 8px;
  overflow: hidden;
}
.recipe-image {
  width: 100%;
  height: 100%;
}
.image-placeholder {
  width: 100%;
  height: 186px;
}

.recipe-name {
  font-size: 0.9rem;
  overflow: hidden;
  line-height: 1.3em; /* Adjust for desired line spacing */
  height: 2.6em; /* Height for 2 lines (2 * 1.3em) */
  display: -webkit-box;
  line-clamp: 2;
  -webkit-line-clamp: 2; /* Limit to 2 lines */
  -webkit-box-orient: vertical;
}

img {
  transition: transform 0.3s ease-in-out;
}
img:hover {
  transform: scale(1.03);
}
.publish-toggle {
  font-size: 1.2rem;
  cursor: pointer;
  transition: opacity 0.2s;
}
.publish-toggle.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
